module.exports = __webpack_public_path__ + "img/Radio-on.3348a2ea.svg";